module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"auth.loader_text":"Загрузка системы..."},"en":{"auth.loader_text":"System loading..."}}')
  delete Component.options._Ctor
}
